import {validateDatoCmsTypes} from './common.serde'
import {VideoSection} from '../types/video-section.types'
import {parseRichVideo} from './rich-text.serde'
import {parseCallToAction} from './call-to-action.serde'
import {VideoSectionFieldsFragment} from '../../../../__generated__/datocms.types'

export function parseVideoSection(a: VideoSectionFieldsFragment): VideoSection {
  const videoSection = validateDatoCmsTypes(a)

  return {
    __type: 'VideoSection',
    id: videoSection.id,
    title: videoSection.title,
    subtitle: videoSection.subtitle,
    description: videoSection.description,
    video: parseRichVideo(videoSection.video),
    callToAction: videoSection.callToAction ? parseCallToAction(videoSection.callToAction) : undefined,
  }
}
